<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="预览"
      top="10px"
      width="1200px"
      @close="close">
    <pdf-preview ref="pdfRead" :pdf-url="model.url"/>
  </el-dialog>
</template>

<script>
  import PdfPreview from "@/components/PdfPreview1";

  export default {
    components: {
      PdfPreview,
    },
    data() {
      return {
        dialogVisible: false,
        pdfLoading: false,
        model: {
          url: "",
        },
      };
    },

    methods: {
      open(filePath) {
        if (filePath) {
          this.dialogVisible = true;
          this.model.url = "";

          this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`).then((res) => {
            if (res.success) {
              // this.$refs.pdfPreview.open(res.data);
              this.model.url = res.data;
            }
          }).catch(() => {
          });

          // this.pdfLoading = true;
          // // this.model.url=filePath;
          // // this.pdfLoading = false;
          //
          // this.$http.get("basic", `files/getDownloadUrl?key=${filePath}`).then((res) => {
          //   console.log(res);
          //   if (res.success) {
          //     this.model.url = res.data;
          //   }
          //   this.pdfLoading = false;
          // }).catch(() => {
          //   this.pdfLoading = false;
          // });
        }
      },
      close() {
        this.dialogVisible = false;
      },

    },
  };
</script>
